import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PierhippakModule } from './module/pierhippak/pierhippak.module';
import { PierhipplaModule } from './module/pierhippla/pierhippla.module';
import { PierhippnvModule } from './module/pierhippnv/pierhippnv.module';
import { PierhippalModule } from './module/pierhippal/pierhippal.module';
import { PierhipparModule } from './module/pierhippar/pierhippar.module';
import { PierhippncModule } from './module/pierhippnc/pierhippnc.module';
import { PierhibicoModule } from './module/pierhibico/pierhibico.module';
import { PierhippgaModule } from './module/pierhippga/pierhippga.module';
import { PierhippflModule } from './module/pierhippfl/pierhippfl.module';
import { PierchipragaModule } from './module/pierchipraga/pierchipraga.module';
import { PierhippwvModule } from './module/pierhippwv/pierhippwv.module';
import { PierhippdemoModule } from './module/pierhippdemo/pierhippdemo.module';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    BrowserAnimationsModule,
    PierhippakModule,
    PierhipplaModule,
    PierhippalModule,
    PierhippnvModule,
    PierhipparModule,
    PierhippncModule,
    PierhibicoModule,
    PierhippgaModule,
    PierhippflModule,
    PierchipragaModule,
    PierhippwvModule,
    PierhippdemoModule
    
  ],
  providers: [
    { provide: 'Window', useFactory: () => window },
  ],
  bootstrap: [AppComponent],
  exports: [RouterModule, HttpClientModule],
})
export class AppModule {}
